import { Page } from "../../Container/page";
import { getTitles } from "../../helpers/titles";
import { parseFreezersData } from "../../helpers/data-parses";

export const FreezersPage = () => {
    return (
        <Page
            titles={getTitles("freezers")}
            breadCrumb={
                <div className="flex text-gray-400">
                    <p>FISH MANAGEMENT / </p>&nbsp;
                    <a
                        href="/fish-management/freezers"
                        className="hover:text-purple-600"
                    >
                        FREEZERS
                    </a>
                </div>
            }
            header={"Freezers"}
            url={"freezers"}
            parseData={parseFreezersData}
        />
    );
};
